import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { AccountService } from '../account.service';
import { CheckPasswordDTO } from '../profile/account.dto';
import { MessagingService } from 'src/app/shared/services/messaging.service';
import { PhotoService } from 'src/app/shared/services/photo.service';
@Component({
  selector: 'app-deactivate',
  templateUrl: './deactivate.page.html',
  styleUrls: ['./deactivate.page.scss'],
})
export class DeactivatePage implements OnInit, OnDestroy {
  deleteSub: Subscription;
  userSub: Subscription;
  checkPasswordSub: Subscription;
  userId: number;
  password: string = '';
  constructor(
    private router: Router,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private authService: AuthService,
    private accountService: AccountService,
    private toastController: ToastController,
    private messagingService: MessagingService,
    private photoService: PhotoService
  ) { }

  ngOnInit() {
    this.userSub = this.authService.user.subscribe(async (user) => {
      if (user) {
        this.userId = user.id;
      }
    });
  }

  goToChangePassword() {
    this.router.navigateByUrl('/change-password');
  }

  confirmPasswordAndDelete() {
    if (this.password.trim().length == 0) {
      this.alertCtrl
        .create({
          header: 'Incorrect Password',
          message: 'Incorrect password. Please try again.',
          buttons: [
            {
              text: 'Dismiss',
              handler: () => {
                this.alertCtrl.dismiss();
              },
            },
          ],
        })
        .then((alertEl) => alertEl.present());
      return;
    }
    this.loadingCtrl
      .create({
        keyboardClose: true,
        showBackdrop: false,
        message: 'Please Wait...',
      })
      .then((loadingEl) => {
        loadingEl.present();
        const credentials: CheckPasswordDTO = {
          userId: this.userId,
          password: this.password,
        };
        this.checkPasswordSub = this.accountService
          .checkPassword(credentials)
          .subscribe({
            next: async (res) => {
              loadingEl.dismiss();
              if (res) {
                this.deleteProfile();
              } else {
                this.alertCtrl
                  .create({
                    header: 'Incorrect Password',
                    message: 'Incorrect password. Please try again.',
                    buttons: [
                      {
                        text: 'Dismiss',
                        handler: () => {
                          this.alertCtrl.dismiss();
                        },
                      },
                    ],
                  })
                  .then((alertEl) => alertEl.present());
              }
            },
            error: (err) => loadingEl.dismiss(),
          });
      });
  }

  deleteProfile() {
    this.alertCtrl
      .create({
        header: 'Delete Account?',
        message:
          'This action cannot be undone! Are you sure you want to delete your account?',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              this.alertCtrl.dismiss();
            },
          },
          {
            text: 'Delete',
            cssClass: 'confirm-delete',
            handler: () => {
              this.performDelete();
              this.alertCtrl.dismiss();
            },
          },
        ],
      })
      .then((alertEl) => alertEl.present());
  }

  performDelete() {
    this.loadingCtrl
      .create({
        keyboardClose: true,
        showBackdrop: false,
        message: 'Please Wait...',
      })
      .then((loadingEl) => {
        loadingEl.present();
        this.deleteSub = this.authService.deleteProfile(this.userId).subscribe({
          next: async (res) => {
            loadingEl.dismiss();
            let success = true;
            if (!res || (res.length === 1 && res[0] === 'Failed')) {
              success = false;
            }
            if (success) {
              res.forEach(img => {
                this.photoService.deleteImageFromFirebase(img).catch(err => {
                  console.error('Error deleting image:', err);
                });
              });
              this.logout();
              const toast = await this.toastController.create({
                color: 'primary',
                duration: 2000,
                message: 'Account deleted successfully.',
              });
              await toast.present();
            } else {
              this.alertCtrl
                .create({
                  header: 'An Error Occured',
                  message:
                    'We cannot perform this action at the moment. Please try again later.',
                  buttons: [
                    {
                      text: 'Dismiss',
                      handler: () => {
                        this.alertCtrl.dismiss();
                      },
                    },
                  ],
                })
                .then((alertEl) => alertEl.present());
            }
          },
          error: (err) => loadingEl.dismiss(),
        });
      });
  }

  async logout() {
    const userId = await this.authService.getUserId();
    await this.messagingService.unregisterToken(userId);
    this.authService.logout();
  }

  ngOnDestroy() {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
    if (this.deleteSub) {
      this.deleteSub.unsubscribe();
    }
  }
}
